import React from 'react';
import { Container } from 'react-bootstrap';

function Footer() {
  const siteName = process.env.REACT_APP_SITE_NAME;
  return (
    <footer className="bg-dark text-white mt-5 p-4 text-center">
      <Container>
        <p className="mb-0">&copy; 2024 {siteName}</p>
      </Container>
    </footer>
  );
}

export default Footer;